


























































import Vue from "vue";
import ApiService from "@/services/ApiService";

export default Vue.extend({
  name: "Login",
  data: function () {
    return {
      username: "",
      password: "",
      error: "",
    };
  },
  mounted() {
    // check if already logged in
    if (ApiService.isLoggedIn()) this.$router.replace({ name: "Home" });
  },
  methods: {
    onLogin() {
      this.error = "";
      ApiService.login(this.username, this.password).catch(
        (err) => (this.error = err.toString())
      );
    },
  },
});
